export interface AttemptStaffFlagInput {
  late?: boolean;
  submissionSource?: string | null;
  hasPendingLateAnswers?: boolean;
  multiDevice?: boolean;
  hasConnectionGaps?: boolean;
}

const AUTO_SOURCES = new Set(['auto', 'sweep']);

export function AttemptStaffFlags({
  late,
  submissionSource,
  hasPendingLateAnswers,
  multiDevice,
  hasConnectionGaps,
}: AttemptStaffFlagInput) {
  const flags = [
    AUTO_SOURCES.has(submissionSource ?? '') ? 'Enviado automáticamente' : null,
    submissionSource === 'offline' ? 'Enviado sin conexión' : null,
    late ? 'Con atraso' : null,
    hasPendingLateAnswers ? 'Respuestas tardías pendientes' : null,
    multiDevice ? 'Varios dispositivos' : null,
    hasConnectionGaps ? 'Hubo cortes de conexión durante el intento' : null,
  ].filter((flag): flag is string => Boolean(flag));
  if (flags.length === 0) return null;
  return (
    <span className="lms-attempt-flags">
      {flags.map((flag) => (
        <span key={flag} className="lms-quiz-review__badge lms-quiz-review__badge--pending">
          {flag}
        </span>
      ))}
    </span>
  );
}

const EVENT_LABELS: Record<string, string> = {
  started: 'Inicio',
  duplicate_submit: 'Envío duplicado',
  late_payload_received: 'Respuestas tardías recibidas',
  multi_device: 'Otro dispositivo',
  late_file_rejected: 'Archivo rechazado por tiempo',
  late_answers_incorporated: 'Respuestas tardías incorporadas',
  expired_empty: 'Cerrado sin respuestas',
  connection_gaps: 'Corte de conexión',
};

export function attemptEventLabel(type: string): string {
  return EVENT_LABELS[type] ?? type;
}

export function hasPendingLateEvents(events: Array<{ type: string }> | undefined): boolean {
  let pending = false;
  for (const event of events ?? []) {
    if (event.type === 'late_payload_received') pending = true;
    if (event.type === 'late_answers_incorporated') pending = false;
  }
  return pending;
}
